import axios from "axios";

class Tags {
    get() {
        return axios.get('/api/v1/tags');
    }

    addTagsToUser(userId, tags = []) {
        return axios.post(`/api/v1/users/${userId}/tags`, {
            tags: tags
        })
    }

    removeTagsFromUser(userId, tags = []) {
        return axios.delete(`/api/v1/users/${userId}/tags`, {
            data: {
                tags: tags
            }
        })
    }
}

export default Tags